<template>
  <div class="form-select-custom__content" @click="onClickContent($event)">
    <ul>
      <li v-for="(option, index) in inputOptions" :key="index" :class="status.value" @click="selectOption(status)">
        {{ option.text }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "FormSelectCustomContent",
  props: {
    inputModel: {
      type: String,
      default: ""
    },
    fieldname: {
      type: String,
      default: ""
    },
    inputOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showContent: false
    };
  },
  computed: {
    status: {
      get() {
        return this.inputOptions.find(el => el.value === this.inputModel).text;
      }
    }
  },
  mounted() {
    document.body.addEventListener("click", this.onBodyClick);
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.onBodyClick);
  },
  methods: {
    onClickContent(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    onBodyClick() {
      this.$emit("close");
    },
    selectOption(status) {
      this.$emit("updateData", { value: status.value, fieldname: this.fieldname });
      this.$emit("close");
    }
  }
};
</script>
